export enum ToothPart {
  root = 'root',
  crown = 'crown',
}
